export default __webpack_public_path__ + "static/media/Asset 13.04180868.png";